//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// @ is an alias to /src
import { required } from 'vuelidate/lib/validators'

const orcolumns = [
  { name: 'create_time', label: '下单时间', field: 'create_time' },
  { name: 'number', label: '单号', field: 'number' },
  { name: 'statusName', label: '状态', field: 'statusName' },
  { name: 'adminName', label: '制单人', field: 'adminName' },
  { name: 'typeName', label: '订单类型', field: 'typeName' },
  { name: 'channel', label: '渠道', field: 'channel' },
  { name: 'order_type', label: '服务种类', field: 'order_type' },
  { name: 'name', label: '客户姓名', field: 'name' },
  { name: 'mobile', label: '客户电话', field: 'mobile' },
  { name: 'fullAddress', label: '客户地址', field: 'fullAddress' },
  { name: 'title', label: '购买商品', field: 'title' },
  { name: 'isTakeMachine', label: '是否带机', field: 'isTakeMachine' },
  { name: 'parts_count', label: '商品数量', field: 'parts_count' },
  { name: 'total_price', label: '商品总价', field: 'total_price' },
  { name: 'companyName', label: '所属公司', field: 'companyName' },
  { name: 'salesman', label: '业务员', field: 'salesman' },
  { name: 'authStatusName', label: '审核状态', field: 'authStatusName' },
  { name: 'payee', label: '交款人', field: 'payee' },
  { name: 'tplus_number', label: 'T+单号', field: 'tplus_number' },
  { name: 'rel_asf_number', label: '派工单号', field: 'rel_asf_number' },
  { name: 'derive_count', label: '派生数', field: 'derive_count' },
  { name: 'inputMachineNumberStatus', label: '编号输入状态', field: 'inputMachineNumberStatus' },
  { name: 'door_date', label: '安装日期', field: 'door_date' },
  { name: 'lockName', label: '锁定状态', field: 'lockName' },
  { name: 'rel_order_numbers', label: '原订单号', field: 'rel_order_numbers' },
]


export default {
  name: 'Home',
  data() {
    return {
      selected:[],
      form: {
        username: '',
        password: '',
        vcode: ''
      },
      filter:'',
      loading: false,
      pagination: {
        sortBy: 'desc',
        descending: false,
        page: 1,
        rowsPerPage: 1,
        rowsNumber: 20
      },
      orderTabelColumns: orcolumns,
      orders: [],
      orderOptions: [],
      orderModel: null,
      loading4: false
    }
  },
  components: {
    required
  },
  validations: {
    form: {
      username: { required }
    }
  },
  mounted() {
    var that = this;
    this.loading = true
    this.onRequest({
      pagination: this.pagination,
      filter: undefined
    });
  },
  methods: {
    onRequest(props){
      console.log(props)
      var that=  this
      let pagin  = props.pagination
      let kk = ''
      if(props.filter!=undefined){
        kk = props.filter
      }
      this.$axios
      .get('/api/beijing/productOrder/list?sys=quasar&page='+pagin.page+"&kk="+kk)
      .then(function (response) {
        that.loading = false
        let data = response.data;
        that.orders = data.rows;
        that.pagination.page = data.pageInfo.page
        that.pagination.rowsPerPage = data.pageInfo.size
        that.pagination.rowsNumber = data.total
        })
      .catch(function (error) { // 请求失败处理
        that.loading = false
        console.log(error);
      });
    },
    dblclick(evt, row){
      console.log(row)
      this.$router.push('/order/detail/'+row['enId'])
    },
    pushToTPlus(){
      if(this.selected.length<1){
        this.$q.notify({
          message: '提示',
          caption: '请选择需要操作的记录',
          color: 'purple'
        })
        return;
      }
      let row = this.selected[0];
      var enIds = [];
      if(row['status']!=3){
          enIds.push(row['enId']);
      }
      if(row['type']==22){
        this.$q.notify({
          message: '提示',
          caption: '虚拟订单不能推送到T+',
          color: 'purple'
        })
        return;
      }
      if(enIds.length<1){
        this.$q.notify({
          message: '提示',
          caption: '所选订单状态错误，无法执行此命令+',
          color: 'purple'
        })
        return;
      }

      let that = this
      this.$q.dialog({
        title: '确认框',
        message: '确认要把选中的订单需要推送到T+?',
        cancel: true,
        persistent: true
          }).onOk(() => {
            console.log('>>>> OK')
            that.$q.loading.show()
            that.$axios.post('/api//beijing/productOrder/pushToTPlus',enIds)
            .then(res=>{
                console.log('res=>',res);     
                that.$q.loading.hide() 
                if (res.data.status == 0) {
                  that.showSuccess()
                  this.onRequest({
                    pagination: this.pagination,
                    filter: this.filter
                  });
                }else{
                  that.showError(res.data.errmsg)
                }
            })
          }).onOk(() => {
            console.log('>>>> second OK catcher')
          }).onCancel(() => {
            console.log('>>>> Cancel')
          }).onDismiss(() => {
            // console.log('I am triggered on both OK and Cancel')
          })

    },
    readTPlus(){
      if(this.selected.length<1){
        this.$q.notify({
          message: '提示',
          caption: '请选择需要操作的记录',
          color: 'purple'
        })
        return;
      }
      let selected = this.selected[0];
      if(selected['status']<1){
        this.$q.notify({
          message: '提示',
          caption: '已推送到T+的订单才需要回读',
          color: 'purple'
        })
          return;
      }
      
      let that = this;
      let data = {enId:selected['enId']}
      this.$q.loading.show()
      this.$axios.post('/api/partsOrder/readTPlus',data)
      .then(res=>{
          console.log('res=>',res);     
          that.$q.loading.hide() 
          that.showSuccess();
      })
    },
    showSuccess() {
      this.$q.notify({
        message: '提示',
        caption: '操作成功',
        color: 'secondary'
      })
    },
    showError(msg) {
      this.$q.dialog({
        title: '出错了',
        message: msg
      }).onOk(() => {
        // console.log('OK')
      }).onCancel(() => {
        // console.log('Cancel')
      }).onDismiss(() => {
        // console.log('I am triggered on both OK and Cancel')
      })
    }
  }
}
